
import { useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export const useCreateSubscription = (refreshData: () => void) => {
  const { toast } = useToast();

  // Create new subscription for user without one
  return useCallback(async (userId: string, plan: string) => {
    try {
      const { data, error } = await supabase
        .from('subscriptions')
        .insert({
          user_id: userId,
          plan: plan,
          status: 'active'
        })
        .select();
      
      if (error) {
        console.error('Error creating subscription:', error);
        toast({
          title: 'Failed to create subscription',
          description: error.message,
          variant: 'destructive',
        });
        return false;
      }

      toast({
        title: 'Subscription created',
        description: `New ${plan} subscription created for customer`,
      });

      // Refresh data to show the new subscription
      refreshData();
      return true;
    } catch (err: any) {
      console.error('Error creating subscription:', err);
      toast({
        title: 'Operation failed',
        description: err.message || 'An error occurred while creating the subscription',
        variant: 'destructive',
      });
      return false;
    }
  }, [toast, refreshData]);
};
